module.exports = __webpack_public_path__ + "assets/img/logo-splash@2x.e9d94d38.png";